<template>
    <v-container class="panelgrid">
        <v-row>
            <v-col cols="6">
                <h1>Identidade de grupo - {{ title }}</h1>
            </v-col>
            <v-col cols="6">
                <v-btn color="primary"
                       v-if="is_admin"
                       :disabled="loading"
                       @click="toggleMode($event)">
                    {{ selection === "NewContext" ? "Editar configurações" : "Cadastrar contexto" }}
                </v-btn>
            </v-col>
        </v-row>
        <v-row v-if="loading" class="justify-center align-center">
            <v-progress-circular :size="35"
                                 color="primary"
                                 indeterminate />
        </v-row>
        <component :is="selection"
                   :locked="loading"
                   @loading="updateLoading"></component>
    </v-container>
</template>

<style lang="css" scoped>
.panelgrid {
    width: 100%;
    height: fit-content;
}
.panelgrid .row h1 {
    font-size: 1.25rem;
}
</style>

<style lang="css">
</style>

<script lang="js">
import NewContext  from './components/NewContext.vue';
import EditContext from './components/EditContext.vue';

export default              {
    data                    () {
        return              {
            title           : '',
            selection       : '',
            is_admin        : false,
            loading         : false,
            no_context      : false,
        }
    },
    components              : {
        EditContext,
        NewContext
    },
    methods                 : {
        updateLoading       (state) { this.loading = state; },
        toggleMode          (ev) {
            ev && ev.preventDefault();
            this.selection  = this.selection === "NewContext" ?
                              "EditContext" :
                              "NewContext";
            this.title      = this.selection === "NewContext" ?
                              "Criar" :
                              "Editar configurações";
        }
    },
    mounted                 () {
        this.is_admin       = this.$store &&
                              this.$store.getters &&
                              this.$store.getters.$user &&
                              this.$store.getters.$user.systemRoleId &&
                              this.$store.getters.$user.systemRoleId === 1 ||
                              false;
        const userContext   = this.$store &&
                              this.$store.getters &&
                              this.$store.getters.$user &&
                              this.$store.getters.$user.userContext;
        this.no_context     = !userContext;
        this.title          = this.no_context ?
                              'Criar' :
                              'Editar configurações';
        this.selection      = this.no_context ?
                              'NewContext' :
                              'EditContext';
    }
}
</script>